var map = {
	"./1.jpg": 5288,
	"./cityair-has-verified-air-quality-data-from-airquality.report-and-agreed-on-project-integration-into-the--airvoice-platform_1.jpg": 3853,
	"./cityair-maps.jpg": 7853,
	"./cityair-mini-station.jpg": 403,
	"./how-cityair-monitors-may-be-used-for-volcanic-eruptions-control-and-notifications_1.jpg": 9272,
	"./news-roundabout.jpg": 3524,
	"./test.jpg": 3613,
	"./whoosh-and-cityair-launched-kick-scooters-with-air-quality-sensors.jpg": 3005
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1392;